import {getDeviceId} from "./Storage";


const GO_EDU_AUTH_URL = process.env.REACT_APP_GO_EDU_AUTH_URL;

export const redirectAuth = (funcName: "login" | "register", callbackUrl?: string) => {
    sessionStorage.clear();
    setTimeout(() => {
        let redirectUrl = callbackUrl || window.location.origin + window.location.pathname;
        let searchArr: string[] = [];
        if (window.location.search) {
            searchArr = window.location.search.replace("?", "").split("&");
            searchArr = searchArr.reduce((previousValue: string[], currentValue: string) => {
                if (
                    !/code=/.test(currentValue) &&
                    !/sv=/.test(currentValue) &&
                    !/exp=/.test(currentValue) &&
                    !/timeserver=/.test(currentValue) &&
                    !/uid=/.test(currentValue)
                ) previousValue.push(currentValue);
                return previousValue;
            }, []);
        }
        const href =
            GO_EDU_AUTH_URL +
            "/" + funcName +
            "?client_id=" + (getDeviceId() || "") +
            "&redirect_uri=" + redirectUrl +
            "&sv=" + process.env.REACT_APP_SERVICE_CODE +
            (searchArr.length ? "&" + searchArr.join("&") : "");
        // console.debug(href);
        window.location.replace(href);
    }, 300);
};
